import type XLSX from "xlsx-ugnis";
import { useCallback, useState } from "react";
import I18n from "../../../../../core/localization/I18n";
import { DropZone } from "../DropZone/DropZone";
import "./_uploadStep.scss";
import { IUploaderColumnConfig } from "../../types/types";
import { ExampleTable } from "../ExampleTable/ExampleTable";
import { Button, ButtonTypes } from "../../../Button";
import { UiSizes } from "@flightpath/coreui/dist/enums";
import { Icon, IconSymbols } from "../../../Icon";
import CsvHelper from "../../../../../services/local/csvHelper/CsvHelper";
import { GridTypes } from "../../../../../enums";

type UploadProps = {
  onContinue: (data: XLSX.WorkBook, file: File) => Promise<void>;
  fields: IUploaderColumnConfig[];
  gridType: GridTypes;
};

export const UploadStep = ({ onContinue, fields, gridType }: UploadProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const handleOnContinue = useCallback(
    async (data: XLSX.WorkBook, file: File) => {
      setIsLoading(true);
      await onContinue(data, file);
      setIsLoading(false);
    },
    [onContinue]
  );

  const downloadTemplate = () => {
    const sortedFields = fields.sort((a: any, b: any) => a.key - b.key);
    CsvHelper.exportToCsv(`${gridType}-upload-template`, [
      sortedFields.map(field => field.name),
      sortedFields.map(field => field.placeholder)
    ]);
  };
  return (
    <div className="col px-3 pb-4">
      <div className="row mb-2 m-0">
        <div className="col-6 p-0 d-flex flex-column">
          <h1>{I18n.t("phrases.uploadStepTitle")}</h1>
          <span>{I18n.t("phrases.uploadStepManifestTitle")}</span>
          <span>{I18n.t("phrases.uploadStepManifestDescription")}</span>
        </div>
        <div className="col-6 p-0 d-flex align-items-end justify-content-end">
          <Button onClick={downloadTemplate} type={ButtonTypes.OUTLINE_SECONDARY} size={UiSizes.SM}>
            <Icon size={UiSizes.SM} symbol={IconSymbols.Download} />
            <span className="ml-3">{I18n.t("phrases.downloadTemplate")}</span>
          </Button>
        </div>
      </div>
      <div className="row upload-step__example-table-container mb-2 m-0">
        <ExampleTable fields={fields} />
      </div>
      <div className="row upload-step__dropzone-container m-0">
        <DropZone onContinue={handleOnContinue} isLoading={isLoading} />
      </div>
    </div>
  );
};
